module.exports = __webpack_public_path__ + "img/tittle2.3b5621e6.png";